.container {
    display: flex;
    gap: 16px;
    width: 100%;
    min-height: 296px;
}
